// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-license-container {
  padding: 40px 24px;
  background-color: #f8fafc;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.update-license-card-shell {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  width: 100%;
  max-width: 800px;
  padding: 32px;
}

.update-license-header {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
  margin-bottom: 24px;
}

.update-license-header h2 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
}

.update-license-header p {
  margin: 6px 0 0 0;
  color: #64748b;
  font-size: 14px;
}

.form-readonly-group-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.readonly-box {
  background-color: #f1f5f9;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.readonly-box label {
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
  display: block;
  margin-bottom: 4px;
}

.readonly-box p {
  margin: 0;
  font-weight: 700;
  color: #1e293b;
  font-size: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.readonly-input-field {
  background-color: #fafafa;
  border: 1px solid #cbd5e1;
  padding: 10px 12px;
  border-radius: 6px;
  font-family: monospace;
  color: #0284c7;
  font-weight: 600;
  cursor: not-allowed;
}

.form-divider {
  border: 0;
  border-top: 1px dashed #cbd5e1;
  margin: 24px 0;
}

.form-input-group-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group select,
.form-group input {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background-color: #fff;
  color: #0f172a;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.form-group select:focus,
.form-group input:focus {
  border-color: #0f172a;
}

/* Quick extension node rules */
.quick-renew-section {
  background: #f8fafc;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin: 16px 0 24px 0;
}

.quick-renew-label {
  font-size: 13px;
  font-weight: bold;
  color: #475569;
  display: block;
  margin-bottom: 8px;
}

.quick-renew-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.quick-renew-actions button {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  transition: all 0.15s ease;
}

.quick-renew-actions button:hover {
  background-color: #0f172a;
  color: #ffffff;
  border-color: #0f172a;
}

.update-license-footer-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}

.btn-cancel-matrix {
  background: #fff;
  border: 1px solid #cbd5e1;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #475569;
}

.btn-submit-matrix {
  background: #0f172a;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
}

.license-alert-error {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-weight: 500;
}

.license-alert-success {
  background-color: #dcfce7;
  color: #15803d;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-weight: 500;
}

@media (max-width: 640px) {
  .form-readonly-group-grid,
  .form-input-group-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/License/UpdateLicense.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kFAAkF;EAClF,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".update-license-container {\n  padding: 40px 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.update-license-card-shell {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n  width: 100%;\n  max-width: 800px;\n  padding: 32px;\n}\n\n.update-license-header {\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 16px;\n  margin-bottom: 24px;\n}\n\n.update-license-header h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.update-license-header p {\n  margin: 6px 0 0 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.form-readonly-group-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.readonly-box {\n  background-color: #f1f5f9;\n  padding: 12px 16px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.readonly-box label {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #64748b;\n  font-weight: 700;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.readonly-box p {\n  margin: 0;\n  font-weight: 700;\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.readonly-input-field {\n  background-color: #fafafa;\n  border: 1px solid #cbd5e1;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-family: monospace;\n  color: #0284c7;\n  font-weight: 600;\n  cursor: not-allowed;\n}\n\n.form-divider {\n  border: 0;\n  border-top: 1px dashed #cbd5e1;\n  margin: 24px 0;\n}\n\n.form-input-group-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group select,\n.form-group input {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  background-color: #fff;\n  color: #0f172a;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.form-group select:focus,\n.form-group input:focus {\n  border-color: #0f172a;\n}\n\n/* Quick extension node rules */\n.quick-renew-section {\n  background: #f8fafc;\n  padding: 14px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  margin: 16px 0 24px 0;\n}\n\n.quick-renew-label {\n  font-size: 13px;\n  font-weight: bold;\n  color: #475569;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.quick-renew-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.quick-renew-actions button {\n  background-color: #ffffff;\n  border: 1px solid #cbd5e1;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  transition: all 0.15s ease;\n}\n\n.quick-renew-actions button:hover {\n  background-color: #0f172a;\n  color: #ffffff;\n  border-color: #0f172a;\n}\n\n.update-license-footer-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}\n\n.btn-cancel-matrix {\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #475569;\n}\n\n.btn-submit-matrix {\n  background: #0f172a;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #fff;\n}\n\n.license-alert-error {\n  background-color: #fee2e2;\n  color: #b91c1c;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n\n.license-alert-success {\n  background-color: #dcfce7;\n  color: #15803d;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n\n@media (max-width: 640px) {\n  .form-readonly-group-grid,\n  .form-input-group-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
